import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const invitationSubject = "Uitnodiging voor het THRM portal";
export function invitationEmail(invitation) {
  return `Beste ${invitation.user.name},

Je hebt toegang gekregen tot het THRM portal.
Maak via onderstaande link je eigen wachtwoord aan:

${invitation.acceptance_url}

Deze link is 48 uur geldig en kan eenmalig worden gebruikt.
Daarna kun je inloggen op https://portal.thrm.online/ met ${invitation.user.email} en je eigen wachtwoord.

Met vriendelijke groet,
Total Hydraulics`;
}

export function escapeInvitationHtml(value) {
  return String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
}
export function invitationEmailHtml(invitation) {
  const url = invitation.acceptance_url;
  const safe = /^https:\/\/portal\.thrm\.online\/uitnodiging#[A-Za-z0-9_-]{43}$/.test(url);
  const escaped = escapeInvitationHtml(url);
  const link = safe ? `<a href="${escaped}" target="_blank" rel="noopener noreferrer">${escaped}</a>` : escaped;
  return `<div><p>Beste ${escapeInvitationHtml(invitation.user.name)},</p><br><p>Je hebt toegang gekregen tot het THRM portal.<br>Maak via onderstaande link je eigen wachtwoord aan:</p><br><p>${link}</p><br><p>Deze link is 48 uur geldig en kan eenmalig worden gebruikt.<br>Daarna kun je inloggen op https://portal.thrm.online/ met ${escapeInvitationHtml(invitation.user.email)} en je eigen wachtwoord.</p><br><p>Met vriendelijke groet,<br>Total Hydraulics</p></div>`;
}

export default function InvitationResult({ invitation, onClose }) {
  const [message, setMessage] = useState("");
  const [manualFallback, setManualFallback] = useState(false);
  if (!invitation) return null;
  const text = invitationEmail(invitation);
  const html = invitationEmailHtml(invitation);
  const copy = async (value, rich = false) => {
    setManualFallback(false);
    if (rich && navigator.clipboard?.write && typeof ClipboardItem !== "undefined") {
      try {
        await navigator.clipboard.write([new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([text], { type: "text/plain" }),
        })]);
        setMessage("E-mailtekst met klikbare link gekopieerd. Plak met opmaak in je e-mailprogramma.");
        return;
      } catch { /* Fall back to plain text when rich clipboard access is unavailable. */ }
    }
    try {
      await navigator.clipboard.writeText(value);
      setMessage(rich ? "Alleen platte tekst gekopieerd. Je e-mailprogramma moet de URL zelf als link herkennen." : "Gekopieerd.");
    } catch {
      setManualFallback(true);
      setMessage("Kopiëren is niet gelukt. Selecteer de tekst hieronder en kopieer deze handmatig.");
    }
  };
  return <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto">
      <DialogHeader><DialogTitle>Uitnodiging zelf versturen</DialogTitle></DialogHeader>
      <p className="text-sm">Aan: {invitation.user.email}</p>
      <p className="text-sm text-muted-foreground">Er is geen e-mail verzonden. Kopieer de tekst naar je eigen e-mailprogramma. Na sluiten is deze link niet meer opvraagbaar; een nieuwe link maakt de vorige ongeldig.</p>
      <label className="text-sm">Onderwerp<input aria-label="Onderwerp" readOnly value={invitationSubject} className="mt-1 w-full rounded border bg-background p-2" /></label>
      <Button variant="outline" onClick={() => copy(invitationSubject)}>Onderwerp kopiëren</Button>
      <div aria-label="Uitnodigingsmail" className="break-words rounded border bg-background p-3 text-sm [&_a]:text-primary [&_a]:underline" dangerouslySetInnerHTML={{ __html: html }} />
      {manualFallback && <textarea aria-label="Handmatig kopiëren" readOnly value={text} rows={8} className="w-full rounded border bg-background p-3 text-sm" />}
      <div className="flex flex-wrap gap-2"><Button onClick={() => copy(text, true)}>E-mailtekst kopiëren</Button><Button variant="outline" onClick={() => copy(invitation.acceptance_url)}>Link kopiëren</Button><Button variant="outline" onClick={onClose}>Sluiten</Button></div>
      <p role="status" className="text-sm">{message}</p>
    </DialogContent>
  </Dialog>;
}
